import React from 'react'
import { Feed, Divider, Button } from 'semantic-ui-react';
import Labels from './../../../../common/Labels'
import { dispatch } from '@rematch/core';
import momentDate from './../../../../../helpers/momentDate';
import momentTime from './../../../../../helpers/momentTime';
import MomentTime from './../../../../common/MomentTime';
import ImageAvater from '../../../../drive/Components/ImageAvater';
class IssueResolvedCard extends React.Component {

    async setCurrntNotes(data, clickStatus) {
        await dispatch.initiatives.setCurrntNotesAsync(data);
        this.props.issueClick(true, clickStatus);
    }
    resolvedClick = () => {
        this.props.IssueResolvedModal(true);
    }

    render() {
        return (
            <Feed className={`issueMessage ${this.props.resolvedModal}`} >
                <Feed.Event className="pad_10">
                    <ImageAvater user={this.props.selectedActivityData.issueLogComments[0].accountUserId} />
                    <Feed.Content>
                        <Feed.Summary>
                            {this.props.selectedActivityData.issueLogComments[0].accountUserId.firstName} {this.props.selectedActivityData.issueLogComments[0].accountUserId.lastName}
                            <span className="pull-right ff_n f_11">
                                {momentDate(this.props.selectedActivityData.issueLogComments[0].issueDate)}
                            </span>
                        </Feed.Summary>
                        <Feed.Date>
                            <span>Created an issue</span>
                            <span className="pull-right ff_n f_11" style={{ textAlign: "right" }}>
                                {momentTime(this.props.selectedActivityData.issueLogComments[0].issueDate)}
                            </span>
                        </Feed.Date>
                    </Feed.Content>
                </Feed.Event>
                <Divider className="mar_0" />
                <div className="pad_10">

                    <Labels
                        name={<span>Why this is an issue?
                            <span className="pull-right">
                                {this.props.selectedActivityData.issueLogComments[0].accountUserId._id === this.props.user._id ?
                                    <span className="clr-blue cursor-pointer" onClick={() => this.setCurrntNotes(this.props.selectedActivityData.issueLogComments[0], "editIssue")}>Edit</span> : ''}
                            </span>
                        </span>}
                        text={this.props.selectedActivityData.issueLogComments[0].issue}
                        htmlView={true}
                        className="bg-white"
                    />
                    <Labels
                        name="Recommended Actions"
                        text={this.props.selectedActivityData.issueLogComments[0].recommendedActions ? this.props.selectedActivityData.issueLogComments[0].recommendedActions : 'None'}
                        htmlView={true}
                        className="bg-white"
                    />
                </div>

                <div className="pull-right pad_10">
                    {this.props.selectedActivityData.issueLogComments[0].accountUserId._id === this.props.user._id ?
                        <Button onClick={this.resolvedClick} className="button-submit" >Resolve</Button> : ''}
                </div>
            </Feed>

        )
    }
}

export default IssueResolvedCard;


